export const GET_ALL_FACTORIES = "/factories"

export const GET_ALL_FACTORIES_PARANOID = "/factories/all"

export const UPDATE_FACTORIES = "/factories/sla"

export const DELETE_FACTORY_BY_ID = "/factories/:id"

export const RESTORE_FACTORY_BY_ID = "/factories/:id/restore"

export const POST_FACTORY = "/factories"

export const UPDATE_FACTORY = "/factories/:id"

export const GET_FACTORY_BY_ID = "/factories/:id"

export const GET_ALL_SLA_FROM_FACTORY = "/embossing-sla/:id"

export const GET_ALL_SLA_FROM_FACTORY_PARANOID = "/embossing-sla/:id/all"

export const GET_ALL_SLA_FROM_FACTORY_CLIENT_PARANOID =
  "/embossing-sla/:id/all/:clientId"

export const POST_SLA_FOR_FACTORY = "/embossing-sla/:id"

export const UPDATE_SLA_FOR_FACTORY = "/embossing-sla/:factoryId/:id"

export const DELETE_SLA_FACTORY_BY_ID = "/embossing-sla/:factoryId/:id"

export const RESTORE_SLA_FACTORY_BY_ID = "/embossing-sla/:factoryId/:id/restore"
